<div class="container-contenido ">
    <div class="header header-inscripcion" #headerContainer>
        <h1 class="quicksand-medium"> REQUISITOS DE INSCRIPCIÓN </h1>
    </div>
    <div class="content contentDesk">
        <div class="requeriments">
            <div class="requeriment" *ngFor="let requeriment of data.requirements">
                <img [src]="requeriment.icon" alt="">
                <span class="nunito-bold">{{requeriment.text}}</span>
            </div>
            <div class="info">
                <p class="nunito-medium">{{data.requirementText}}</p>
                <p class="nunito-medium">{{data.requirementCalification}}</p>

            </div>

            <div class="additional" *ngFor="let info of data.additionalInformation">
                <div class="header-additional">
                    <img [src]="info.icon" alt="">
                    <span class="quicksand-bold">{{info.title}}</span>
                </div>
                <span class="header-text nunito-medium">{{info.text}}</span>

                <a *ngIf="!info.buttonUrl" (click)="clickButton(info)" class="header-bottom nunito-medium"
                    [style.background-color]="info.buttonBackground" [style.border-color]="info.buttonColor"
                    [style.color]="info.buttonColor" Target="_blank">
                    {{ info.buttonText}}
                    <img *ngIf="info.buttonIcon" class="icon pointer" [src]="info.buttonIcon" alt="">
                </a>

                <a *ngIf="info.buttonUrl" class="header-bottom nunito-medium"
                    [style.background-color]="info.buttonBackground" [style.border-color]="info.buttonColor"
                    [style.color]="info.buttonColor" [href]="info.buttonUrl" Target="_blank">
                    {{ info.buttonText}}
                    <img *ngIf="info.buttonIcon" class="icon pointer" [src]="info.buttonIcon" alt="">
                </a>
            </div>
        </div>
        <div class="qr desk">
            <span class="quicksand-bold"> {{data.qrTitle}}</span>
            <img [src]="data.qrImage" alt="">
        </div>

    </div>
    <div class="content contentMob">
        <div class="requeriments">
            <div class="requeriment" *ngFor="let requeriment of data.requirements">
                <img [src]="requeriment.icon" alt="">
                <span class="nunito-bold">{{requeriment.text}}</span>
            </div>
            <div class="info">
                <p class="nunito-medium">{{data.requirementText}}</p>
                <p class="nunito-medium">{{data.requirementCalification}}</p>

            </div>
            <div class="sectionMobile contentMobile">

                <div class="paragraph nunito-regular" *ngFor="let paragraph of data?.mobileContent[0]?.paragraphs">
                    {{paragraph.text}}
                </div>

                <a class="mobile-bottom  termsConditions nunito-medium"
                    [href]="data?.mobileContent[0]?.termsConditionsRedirectUrl" Target="_blank">
                    VER TÉRMINOS Y CONDICIONES
                </a>

                <a class="mobile-bottom  startEnrollment nunito-medium"
                    [href]="data?.mobileContent[0]?.startEnrollmentRedirectUrl" Target="_blank">
                    ACEPTAR Y COMENZAR LA INSCRIPCIÓN
                </a>

            </div>
            <div class="additional" *ngFor="let info of data.additionalInformation">
                <div class="header-additional">
                    <img [src]="info.icon" alt="">
                    <span class="quicksand-bold">{{info.title}}</span>
                </div>
                <span class="header-text nunito-medium">{{info.text}}</span>

                <a *ngIf="!info.buttonUrl" (click)="clickButton(info)" class="header-bottom nunito-medium"
                    [style.background-color]="info.buttonBackground" [style.border-color]="info.buttonColor"
                    [style.color]="info.buttonColor" Target="_blank">
                    {{ info.buttonText}}
                    <img *ngIf="info.buttonIcon" class="icon pointer" [src]="info.buttonIcon" alt="">
                </a>

                <a *ngIf="info.buttonUrl" class="header-bottom nunito-medium"
                    [style.background-color]="info.buttonBackground" [style.border-color]="info.buttonColor"
                    [style.color]="info.buttonColor" [href]="info.buttonUrl" Target="_blank">
                    {{ info.buttonText}}
                    <img *ngIf="info.buttonIcon" class="icon pointer" [src]="info.buttonIcon" alt="">
                </a>
            </div>
        </div>
        <div class="qr desk">
            <span class="quicksand-bold"> {{data.qrTitle}}</span>
            <img [src]="data.qrImage" alt="">
        </div>

    </div>
    <div class="content-info">
        <div class="info" *ngFor="let option of data.moreInformationOptions">
            <div class="icon">
                <img [src]="option.icon" alt="">
            </div>
            <h3 class="title quicksand-bold  desk">{{option.title}}</h3>
            <h3 class="text nunito-medium moreInformationOptionsText contentDesk">{{option.text}}</h3>
            <h3 class="text-mobile quicksand-bold contentMob">{{option.titleMobile}}</h3>

            <a class="button quicksand-medium" [href]="option.redirectButtonUrl" Target="_blank">
                MÁS INFO
            </a>
        </div>
    </div>
</div>